// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-products-block {
    padding: 2rem 0;
}

.featured-products-header {
    text-align: center;
    margin-bottom: 3rem;
}

.featured-products-header h3 {
    color: var(--admin-color);
    margin-bottom: 1rem;
    font-size: 2rem;
}

.featured-products-header p {
    color: var(--text-color);
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
}

.featured-products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
}

.featured-product-card {
    background: white;
    border-radius: var(--border-radius);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.featured-product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.15);
}

.featured-product-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.featured-product-info {
    padding: 1.5rem;
}

.featured-product-info h4 {
    color: var(--admin-color);
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
}

.featured-product-info p {
    color: var(--text-color);
    margin-bottom: 1rem;
    font-size: 0.9rem;
    line-height: 1.4;
}

.featured-product-price {
    color: var(--admin-color);
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 1rem;
}

.featured-products-footer {
    text-align: center;
}

.featured-products-btn {
    background: var(--admin-color);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: var(--border-radius);
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.featured-products-btn:hover {
    background: var(--button-hover-color);
}

.empty-products {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    background: var(--background-color);
    border: 2px dashed var(--border-color);
    border-radius: var(--border-radius);
    color: var(--text-color);
    opacity: 0.6;
}

.empty-products .mdi {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.empty-products p {
    margin: 0;
    font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/FeaturedProductsBlock/FeaturedProductsBlock.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mCAAmC;IACnC,sCAAsC;IACtC,mCAAmC;IACnC,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB","sourcesContent":[".featured-products-block {\n    padding: 2rem 0;\n}\n\n.featured-products-header {\n    text-align: center;\n    margin-bottom: 3rem;\n}\n\n.featured-products-header h3 {\n    color: var(--admin-color);\n    margin-bottom: 1rem;\n    font-size: 2rem;\n}\n\n.featured-products-header p {\n    color: var(--text-color);\n    max-width: 600px;\n    margin: 0 auto;\n    line-height: 1.6;\n}\n\n.featured-products-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n    margin-bottom: 2rem;\n}\n\n.featured-product-card {\n    background: white;\n    border-radius: var(--border-radius);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n    overflow: hidden;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.featured-product-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 16px rgba(0,0,0,0.15);\n}\n\n.featured-product-image {\n    width: 100%;\n    height: 200px;\n    object-fit: cover;\n}\n\n.featured-product-info {\n    padding: 1.5rem;\n}\n\n.featured-product-info h4 {\n    color: var(--admin-color);\n    margin-bottom: 0.5rem;\n    font-size: 1.2rem;\n}\n\n.featured-product-info p {\n    color: var(--text-color);\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n    line-height: 1.4;\n}\n\n.featured-product-price {\n    color: var(--admin-color);\n    font-weight: bold;\n    font-size: 1.1rem;\n    margin-bottom: 1rem;\n}\n\n.featured-products-footer {\n    text-align: center;\n}\n\n.featured-products-btn {\n    background: var(--admin-color);\n    color: white;\n    border: none;\n    padding: 0.75rem 2rem;\n    border-radius: var(--border-radius);\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s ease;\n    text-decoration: none;\n    display: inline-block;\n}\n\n.featured-products-btn:hover {\n    background: var(--button-hover-color);\n}\n\n.empty-products {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    background: var(--background-color);\n    border: 2px dashed var(--border-color);\n    border-radius: var(--border-radius);\n    color: var(--text-color);\n    opacity: 0.6;\n}\n\n.empty-products .mdi {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n}\n\n.empty-products p {\n    margin: 0;\n    font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
